import { React, useEffect, useState } from 'react';
import style from './../adminSect.module.scss';
import { EyeOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons';
import { CustomPaginate, LoadingTable } from './../../utils/Utils';
import moment from 'moment';

function Table(props) {
  const { usersTable, tablePadding, sellsTBody, id, btnsTd, btnsContainers, loadingComp, usersTableContainer } =
    style;
  const {
    toggleModal,
    conferences,
    setConferenceData,
    showMoreData,
    setShowMoreData,
    totalPages,
    page,
    setPage,
    getConferences,
    setEditingConference,
    setEditConferenceModal,
    editConferenceModal,
    setDeletingConference,
    setDeleteConferenceModal,
    deleteConferenceModal,
    givenPage,
    totalConferences,
    reqStatus,
    search
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [noConferencesFound, setNoConferencesFound] = useState(false);

  useEffect(() => {
    if (conferences.length === 0 && !reqStatus) {
      setNoConferencesFound(false);
      setIsLoading(true);
    } else if (conferences.length === 0) {
      setNoConferencesFound(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setNoConferencesFound(false);
    }
  }, [page, conferences, reqStatus]);

  useEffect(() => {
    if (givenPage !== page || search || search === false) {
      getConferences();
    }
  }, [page, search]);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const modalTrigger = (conf, dataState, set, state) => {
    dataState(conf);
    toggleModal(set, state);
  };

  return (
    <div className={usersTableContainer}>
      <div className={tablePadding}>
        <table className={usersTable}>
          <thead>
            <tr>
              <th>
                <b>Nombre</b>
              </th>
              <th>
                <b>Fecha</b>
              </th>
              <th>
                <b>Disertante</b>
              </th>
              <th>
                <b>URL</b>
              </th>
              <th>
                <b>total de conferencias: {totalConferences}</b>
              </th>
            </tr>
          </thead>
          <tbody className={sellsTBody}>
            {conferences
              ? conferences.map((conf, i) => {
                return (
                  <tr key={i}>
                    <td className={id}>{conf.name}</td>
                    <td>{conf.date ? moment(conf.date).format('DD-MM-YYYY HH:mm') : ''}</td>
                    <td>{conf.speakers}</td>
                    <td>{conf.youtubeLink}</td>
                    <td>
                      <div className={btnsTd}>
                        <div className={btnsContainers}>
                          <EyeOutlined
                            onClick={() =>
                              modalTrigger(
                                conf,
                                setConferenceData,
                                setShowMoreData,
                                showMoreData,
                              )
                            }
                          />
                          <FormOutlined
                            onClick={() =>
                              modalTrigger(
                                conf,
                                setEditingConference,
                                setEditConferenceModal,
                                editConferenceModal,
                              )
                            }
                          />
                          <DeleteOutlined
                            style={{color: '#F57255'}}
                            onClick={() =>
                              modalTrigger(
                                conf,
                                setDeletingConference,
                                setDeleteConferenceModal,
                                deleteConferenceModal,
                              )
                            }
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
              : ''}
          </tbody>
        </table>
        {isLoading && 
          <div className={loadingComp}>
            <LoadingTable />
          </div>}
        {noConferencesFound && 
          <div className={loadingComp}>
            No se encontraron conferencias
          </div>}
      </div>
      <CustomPaginate setPage={setPage} page={page} totalPages={totalPages} />
    </div>
  );
}

export default Table;
